<style lang="scss" scoped>
.page {
    //min-height: 100vh;
}
.filter-row {
    width: 100%;
    min-height: 67px;
    box-shadow: inset 0 -1px 0 #efefef, inset 0 1px 0 #efefef;
    background-color: #ffffff;
    display: flex;
    align-items: center;

    .filter-button {
        cursor: pointer;
        user-select: none;
        .filter-icon {
            line-height: 0.5rem;
            font-size: 0.5rem;
        }
    }

    .tag-row {
        .tag-sm {
            &:after {
                content: url("/svg/icon-close.svg");
                display: inline-block;
                margin-left: 8px;
            }
        }
    }
}
</style>

<template>
    <div class="page" ref="activitiesFilter">
        <div class="container-fluid mb-32 mb-lg-40">
            <div class="row">
                <div class="filter-row">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 position-relative d-flex flex-row mt-8 align-self-center">
                                <div class="mr-8 mr-md-24" @click.stop="show_filters = !show_filters">
                                    <div class="filter-button d-flex align-items-center tag tag-sm mb-8"><i v-html="svg('filter')" class="mr-8 filter-icon"></i><small class="d-none d-md-block text-accent font-weight-light">Filter</small></div>
                                </div>
                                <div class="tag-row align-items-center">
                                    <div class="tag-col d-flex" v-if="searchText">
                                        <a class="tag tag-accent tag-sm mb-8" @click="clearSearchText" v-html="`“${searchText}”`"></a>
                                    </div>
                                    <div class="tag-col d-flex" v-for="category in selectedCategories" :key="category.id">
                                        <a class="tag tag-accent tag-sm mb-8" @click="toggleAndFilterCategory(category)" v-html="category.name"></a>
                                    </div>
                                </div>
                                <filter-menu v-model="selectedCategories" @input="() => filterActivities()" :grouped-categories="groupedCategories" :show="show_filters" @close="show_filters = false" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if=" !(filteredActivities || activities).length">
            <ask-banner-row class="mb-80 mb-xxl-120" :src="noResultsConfig.image.sizes.large" :title="noResultsConfig.title" :description="noResultsConfig.description" :phone="noResultsConfig.phone" :email="noResultsConfig.email" :cta="noResultsConfig.cta" :cta-link="noResultsConfig.cta_link"></ask-banner-row>
            <div class="container">
                <div class="row">
                    <div class="col">
                        <h3 class="mb-32">Misschien is dit iets voor jou!</h3>
                    </div>
                </div>
            </div>
        </template>
        <activities-row :activities="shownActivities" :ratio="ratio" :force-grid="true" :items-per-row="6"></activities-row>
    </div>
</template>

<script>
import activitesRow from "../mixins/activities-row";
import hasGroupedCategories from "../mixins/has-grouped-categories";
import canToggleCategory from "../mixins/can-toggle-category";
import canFilterFromCategories from "../mixins/can-filter-from-categories";

export default {
    name: "pagePart.activities-filter-row",

    mixins: [activitesRow, hasGroupedCategories, canToggleCategory, canFilterFromCategories],

    props: {
        activities: {
            type: Array,
            default: () => {
                return []
            }
        },
        noResultsConfig: {
            type: Object,
            required: true,
        }
    },

    data: () => ({
        show_filters: false,
        selectedCategories: [],
        searchText: null,
        filteredActivities: null,
        suggestedActivities: [],
        filter: null,
        page: 1,
        perPage: 50,
    }),

    created() {
        let params = new URLSearchParams(location.search)
        let selectedCategories = []
        params.forEach((value, key) => {
            if (key === 'search') {
                this.searchText = value
                return
            }
            const queryCategories = value.split(',')
            selectedCategories = [...selectedCategories, ...queryCategories]
        })
        this.selectedCategories = this.categories.filter(c => {
            return selectedCategories.includes(c.slug)
        })
    },

    mounted() {
        window.addEventListener('scroll', () => {
            if (document.documentElement.scrollTop > this.$refs.activitiesFilter.offsetTop + this.$refs.activitiesFilter.clientHeight - window.innerHeight - 300) {
                this.nextPage()
            }
        })
    },

    methods: {
        toggleAndFilterCategory(category) {
            this.selectedCategories = this.toggleCategory(category)
            this.filterActivities()
        },

        filterActivities: _.debounce(function () {
            this.populateSearchParams().then(filter => {
                this.page = 1
                filter.page = this.page
                filter.per_page = this.perPage
                this.fetchActivities(filter)
            })
        }, 500, { leading: true, trailing: true }),

        clearSearchText() {
            this.searchText = null;
            this.populateSearchParams().then(filter => {
                this.page = 1
                filter.page = this.page
                filter.per_page = this.perPage
                this.fetchActivities(filter)
            })
        },

        nextPage() {
            const availableItems = this.perPage * this.page
            if (availableItems > this.shownActivities.length) {
                return
            }

            this.populateSearchParams().then(filter => {
                this.page += 1
                filter.page = this.page
                filter.per_page = this.perPage
                this.fetchActivities(filter)
            })
        },

        fetchActivities(filter) {
            axios.get(route('search-activities', filter)).then(result => {
                if (!filter.page || filter.page === 1) {
                    this.filteredActivities = result.data
                    return
                }
                this.filteredActivities = [...(this.filteredActivities || this.activities), ...result.data]
            })
        },

        populateSearchParams() {
            return new Promise(resolve => {
                const filter = this.getFilterFromCategories(this.selectedCategories)
                let params = new URLSearchParams()

                if (this.searchText) {
                    filter.search = this.searchText
                }

                for (let param in filter) {
                    params.set(param, filter[param])
                }

                let newUrl = location.pathname
                if (params.toString()) {
                    newUrl += `?${params}`
                }

                window.history.replaceState({}, '', newUrl);

                resolve(filter)
            })
        }
    },

    computed: {
        visibleCategories() {
            return this.categories.filter(c => {
                return c.parent === 0 || !c.acf.meta || c.acf.meta.filter_enabled
            })
        },

        suggestedCategories() {
            if ((this.activities.length && !this.filteredActivities) || (this.filteredActivities && this.filteredActivities.length)) {
                return []
            }

            let suggested = this.selectedCategories.filter(a => this.getTopLevelParent(a).id === 6)
            if (!suggested.length) {
                return this.groupedCategories.find(gc => gc.parent.id === 6).children
            }
            return suggested
        },

        shownActivities() {
            if (this.filteredActivities && this.filteredActivities.length) {
                return this.filteredActivities
            }
            if (this.activities && this.activities.length) {
                return this.activities
            }
            return this.suggestedActivities
        }
    },

    watch: {
        suggestedCategories: {
            handler: function (newValue, oldValue) {
                if (!this.suggestedCategories.length) {
                    this.suggestedActivities = []
                }

                let equals = oldValue && newValue.length === oldValue.length
                if (equals) {
                    for (var i = 0; i < newValue.length; i++) {
                        if (newValue[i].id !== oldValue[i].id) equals = false;
                    }
                }

                if (equals) {
                    return this.suggestedActivities
                }

                const suggestedFilter = this.getFilterFromCategories(this.suggestedCategories)
                this.page = 1
                axios.get(route('search-activities', suggestedFilter)).then(result => {
                    this.suggestedActivities = result.data
                })
            },
            immediate: true
        }
    }
}
</script>